import { PurchaseOrderPDF } from '@received/pricing-model';
import { pdf } from '@react-pdf/renderer';
import { PurchaseOrderData } from './PurchaseOrder.types';
import { triggerDownload } from '../../../../utils/triggerDownload';

export const downloadPurchaseOrderPDF = async (purchaseOrderData: PurchaseOrderData): Promise<void> => {
	const blob = await pdf(<PurchaseOrderPDF purchaseOrderData={purchaseOrderData} isPreview />).toBlob();
	const fileName = `PO-${purchaseOrderData.poNumber || purchaseOrderData.contractNumber || 'document'}.pdf`;
	triggerDownload(blob, fileName);
};
